module.exports = __webpack_public_path__ + "static/media/gold-era-full.be6035c8.png";